<ziro-phone-buttons-line-extension-search
  #form
  [entity]="extensionSearchEntity"
  [isPending]="isLineFeaturePending"
  [phone]="phone()"
  [buttonIndex]="buttonIndex()"
  [parentSubmit$]="parentSubmit$()"
  [dnRef]="dnRef()"
  [lineButtonSummary]="lineButtonSummary()"
  [global360View]="global360View()"
  [isSingleButton]="isSingleButton"
  (directoryNumberCreated)="onDnCreated($event)"
  (ziroFormsUpdate$)="onExtensionChanged($event)"
  (voicemailUpdated)="onVoicemailUpdate($event)"
  (reconsiderLineFeatureSettings)="fetchLineFeature($event)"
></ziro-phone-buttons-line-extension-search>

@if (lineFeature()) {
  <ziro-phone-buttons-line-helpdesk-form
    #form
    [entity]="lineFeature()"
    [extension]="dnRef().extension"
    [fieldConfig]="fieldConfig()"
    [isUccxAgentLine]="lineButtonSummary().isUccxAgent"
    [parentSubmit$]="parentSubmit$()"
    (ziroFormsUpdate$)="onLineFeatureUpdate($event)"
  ></ziro-phone-buttons-line-helpdesk-form>
}
